import Axios from "axios";
import {
    SET_INV_SALES_INVOICE_DELIVERY_LIST,
    UNSET_INV_SALES_INVOICE_DELIVERY_LIST,
    SET_EDITING_INV_SALES_INVOICE_DELIVERY_LIST,
    UNSET_EDITING_INV_SALES_INVOICE_DELIVERY_LIST,
    SET_SALE_INVOICE_DELIVERY_ORDER,
    UNSET_SALE_INVOICE_DELIVERY_ORDER
} from "@/store/mutation-types";
import {
    getInvSalesInvoiceDeliveryList,
    getInvSalesInvoiceDeliveryById as getInvSalesInvoiceDeliveryByIdApi,
    saveUpdateInvSalesInvoiceDelivery,
    getSaleInvoiceDeliveryOrder,
} from "@/store/api";

const state = {
    getInvSalesInvoiceDeliveryList: [],
    editingInvSalesInvoiceDelivery: null,
    getSaleInvoiceDeliveryOrder:null,
};

const getters = {
    getInvSalesInvoiceDeliveryList(state) {
        return state.getInvSalesInvoiceDeliveryList;
    },
    getEditingSalesInvoiceDelivery: (state) => {
        return state.editingInvSalesInvoiceDelivery;
    },
    getSaleInvoiceDeliveryOrder(state) {
        return state.getSaleInvoiceDeliveryOrder;
    },
};

const mutations = {
    [SET_INV_SALES_INVOICE_DELIVERY_LIST](state, data) {
        state.getInvSalesInvoiceDeliveryList = data;
    },
    [UNSET_INV_SALES_INVOICE_DELIVERY_LIST](state) {
        state.getInvSalesInvoiceDeliveryList = [];
    },
    [SET_EDITING_INV_SALES_INVOICE_DELIVERY_LIST](state, data) {
        state.editingInvSalesInvoiceDelivery = data;
    },
    [UNSET_EDITING_INV_SALES_INVOICE_DELIVERY_LIST](state) {
        state.editingInvSalesInvoiceDelivery = null;
    },
    [SET_SALE_INVOICE_DELIVERY_ORDER](state, data) {
        state.getSaleInvoiceDeliveryOrder = data;
    },
    [UNSET_SALE_INVOICE_DELIVERY_ORDER](state) {
        state.getSaleInvoiceDeliveryOrder = null;
    }
};

const actions = {
    saveUpdateInvSalesInvoiceDelivery({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
        Axios.post(saveUpdateInvSalesInvoiceDelivery, data)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (error) {
                reject(error);
            })
            .then((always) => {
                commit("UNSET_LOADING");
            });
        });
    },

    getInvSalesInvoiceDeliveryList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.post(getInvSalesInvoiceDeliveryList, data)
                .then(function (response) {
                    commit("SET_INV_SALES_INVOICE_DELIVERY_LIST", response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit("UNSET_INV_SALES_INVOICE_DELIVERY_LIST");
                    reject(error);
                })
                .then((always) => {});
            }
        );
    },

    getInvSalesInvoiceDeliveryById({ commit }, id) {
        const getInvSalesInvoiceDeliveryById = `${getInvSalesInvoiceDeliveryByIdApi}/${id}`;
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(getInvSalesInvoiceDeliveryById)
                .then((response) => {
                    resolve(response.data.data);
                })
                .catch((error) => {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
    getSaleInvoiceDeliveryOrder({ commit }, id) {
        const getSaleInvoiceDeliveryOrderById = `${getSaleInvoiceDeliveryOrder}/${id}`;
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(getSaleInvoiceDeliveryOrderById)
                .then((response) => {
                    commit("SET_SALE_INVOICE_DELIVERY_ORDER", response.data.data);
                    resolve(response.data.data);
                })
                .catch((error) => {
                    commit("UNSET_SALE_INVOICE_DELIVERY_ORDER");
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        }) 
    },   
};

export default {
    state,
    getters,
    actions,
    mutations,
};
